var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-card',{staticClass:"group-card",attrs:{"elevation":0,"tag":_vm.tag}},[(!_vm.hideTitle)?_c('v-card-title',{class:`px-${_vm.dense ? 2 : 5} pt-3 pb-1 group-card__title text-h${
      _vm.dense ? 5 : 4
    } font-weight-medium`},[_c('div',{staticStyle:{}},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2)]):_vm._e(),_c('div',{class:`mx-${_vm.dense ? 2 : 5}`},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }